import { SparkLineChart } from "@mui/x-charts/SparkLineChart";
import { MarkPlot } from "@mui/x-charts/LineChart";

interface ShredUsageDataPoint {
  value: number;
  label: string;
}

interface ShredUsageSparklineProps {
  dataPoints: ShredUsageDataPoint[];
  color: string;
  width?: number;
  height?: number;
}

export const ShredUsageSparkline = ({
  dataPoints,
  color,
  width = 80,
  height = 32,
}: ShredUsageSparklineProps) => {
  if (dataPoints.length < 2) {
    return null;
  }

  const values = dataPoints.map((dp) => dp.value);
  const labels = dataPoints.map((dp) => dp.label);

  return (
    <SparkLineChart
      data={values}
      xAxis={{
        scaleType: "point",
        data: labels,
      }}
      width={width}
      height={height}
      curve="linear"
      area
      showTooltip
      valueFormatter={(value) => (value != null ? `${value.toFixed(1)}%` : "")}
      slotProps={{
        tooltip: {
          sx: {
            "& .MuiChartsTooltip-mark": {
              borderColor: color,
              backgroundColor: color,
            },
          },
        },
      }}
      sx={{
        "& .MuiLineElement-root": {
          stroke: color,
        },
        "& .MuiAreaElement-root": {
          fill: color,
          fillOpacity: 0.4,
        },
        "& .MuiMarkElement-root": {
          display: "none",
        },
        "& .MuiMarkElement-root:last-of-type": {
          display: "block",
          fill: color,
          stroke: color,
          r: 4,
          transform: "translateX(-4px)",
        },
        "& .MuiHighlightElement-root": {
          fill: color,
          stroke: color,
        },
      }}
    >
      <MarkPlot />
    </SparkLineChart>
  );
};
